import axiosInstance from "../axiosInstance";

export const userSidemenuPreferenceService = {
  fetchByUser: async (userId) => {
    try {
      const response = await axiosInstance.get(
        `/user-sidemenu-preference?user=${userId}&$limit=1`,
      );
      return response.data?.data?.[0] || null;
    } catch (error) {
      throw error;
    }
  },

  create: async (payload) => {
    try {
      const response = await axiosInstance.post(
        "/user-sidemenu-preference",
        payload,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  patch: async (id, payload) => {
    try {
      const response = await axiosInstance.patch(
        `/user-sidemenu-preference/${id}`,
        payload,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  upsert: async (userId, preferences) => {
    try {
      const existing = await userSidemenuPreferenceService.fetchByUser(userId);
      if (existing) {
        return await userSidemenuPreferenceService.patch(existing._id, {
          preferences,
        });
      } else {
        return await userSidemenuPreferenceService.create({
          user: userId,
          preferences,
        });
      }
    } catch (error) {
      throw error;
    }
  },
};
